import React from 'react';
import { Badge } from '@themesberg/react-bootstrap';
import { useTranslation } from "react-i18next";

const ClaimNameCell = ({ claim }) => {
  const { t } = useTranslation();
  const aiData = claim.aiExtractedVariables || {};

  return (
    <td>
      <div className="d-flex align-items-center gap-2">
        <span style={{ fontWeight: 600, color: "#111827" }}> {aiData.DebtorName || claim.name}</span>
        <Badge
          bg="light"
          text="dark"
          style={{
            fontSize: "12px",
            fontWeight: 500,
            border: "1px solid #e5e7eb",
            borderRadius: "6px",
          }}
        >
          {claim.fileReferenceNo}
        </Badge>
      </div>
    </td>
  );
};

export default ClaimNameCell;
